module.exports = __webpack_public_path__ + "static/milkers-avatar-4ee323f88d565281ac37bc12a6f9bdff.jpg";